

import { defineComponent, reactive } from "vue";
import store from "@/store";
import { Service } from "@/store/user/types";
export default defineComponent({    
    name: 'Mp3Settings',
    data() {
        return {            
            loading: false,
            countBlock: 3,
            userServices: [],            
            userService: {} as Service,
            baseAlbumTypes: [
                {id: 1, name: 'Extended Play'},
                {id: 2, name: 'Long Play'},
                {id: 3, name: 'Live'},
                {id: 4, name: 'Compilation'},
                {id: 5, name: 'Single Play'},
                {id: 6, name: 'Soundtrack'},
                {id: 7, name: 'Demo'},
                {id: 9, name: 'Bootleg'}
            ],
            baseGenres: [
                {id: 1, name: 'Рок'},
                {id: 23, name: 'ПрогРок'},
                {id: 24, name: 'ПсихоРок'},
                {id: 2, name: 'Метал'},
                {id: 25, name: 'ЭксМетал'},
                {id: 22, name: 'АльтРок'},
                {id: 3, name: 'Гранж'},
                {id: 4, name: 'Панк'},
                {id: 5, name: 'Блюз'},
                {id: 6, name: 'Джаз'},
                {id: 7, name: 'Поп'},
                {id: 8, name: 'Кантри'},
                {id: 9, name: 'Фолк'},
                {id: 10, name: 'Фанк'},
                {id: 11, name: 'Рэп'},
                {id: 12, name: 'Рэгги'},
                {id: 13, name: 'Соул'},
                {id: 14, name: 'Госпел'},
                {id: 15, name: 'Блюграсс'},
                {id: 16, name: 'Мидивал'},
                {id: 17, name: 'Электронная'},
                {id: 18, name: 'Эмбиент'},
                {id: 19, name: 'Эксперимент.'},
                {id: 20, name: 'Поэзия'},
                {id: 21, name: 'Барды'},
            ],
            genres: [] as number[],
            album_types: [] as number[],
            window: {
                width: 0,
                height: 0
            },
            styleObject: reactive({
                width: '600px'
            })
        }
    },
    created() {
        this.window = store.getters['window/windowSize']
        this.userServices = store.getters['user/userServices']
    },
    watch: { 
        window: {
            handler(newVal) {
                if (newVal.width < 435) {
                    this.countBlock = 2
                } else {
                    this.countBlock = 3
                }
                if (newVal.width < 650 && newVal.width > 300) {
                    this.styleObject.width = (newVal.width - 50) + 'px'
                } else {
                    if (this.styleObject.width !== '600px') {
                        this.styleObject.width = '600px'
                    }
                }               
            },
            deep: true
        },
        userServices: function(newVal) {
            newVal.forEach((element: Service) => {
                if (element.service == '80a6d350-fc81-4116-a8e1-18e02d789980') {
                    this.userService = element
                    this.userService.genres.forEach(element => {
                        if (! this.genres.find((el: number) => el == element)) {
                            this.genres.push(element)
                        }
                    });
                    this.userService.album_types.forEach(element => {
                        if (! this.album_types.find((el: number) => el == element)) {
                            this.album_types.push(element)
                        }
                    });
                }
            }
        )
    },
    },
    methods: {        
        save(id: number, event: any) {            
            if (event.target.checked) {
                this.genres.push(id)   
            } else {
                const filteredGenres = this.genres.filter(genre => genre != id);
                console.log('filteredGenres: ' + filteredGenres)
                this.genres = filteredGenres
            } 
            console.log(this.genres)
            this.userService.genres = []
            this.genres.forEach((element) => {                
                if (! this.userService.genres.find((el: number) => el == element)) {
                    this.userService.genres.push(element)
                }                
            })
            store.dispatch('user/setUserService', this.userService)   
            store.dispatch('mp3player/clearLastUpdate')        
        },
        saveFormat(id: number, event: any) {            
            if (event.target.checked) {
                this.album_types.push(id)   
            } else {
                const filteredAlbumTypes = this.album_types.filter(album_type => album_type != id);
                console.log('filteredAlbumTypes: ' + filteredAlbumTypes)
                this.album_types = filteredAlbumTypes
            } 
            console.log(this.album_types)
            this.userService.album_types = []
            this.album_types.forEach((element) => {                
                if (! this.userService.album_types.find((el: number) => el == element)) {
                    this.userService.album_types.push(element)
                }                
            })
            store.dispatch('user/setUserService', this.userService)   
            store.dispatch('mp3player/clearLastUpdate')        
        }
    }
})
